import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import type { ButtonProps } from "@mui/material/Button";
import { Tooltip } from "@mui/material";

const SIZE = 56;

type IconButtonProps = {
  children?: JSX.Element;
  toolTipText?: string;
} & ButtonProps;

export default function IconButton({ children, toolTipText, ...ButtonProps }: IconButtonProps) {
  return (
    <Tooltip title={toolTipText} placement="left">
      <span>
        <IconContainer {...ButtonProps}>{children}</IconContainer>
      </span>
    </Tooltip>
  );
}

const IconContainer = styled(Button)(({ theme }) => ({
  borderRadius: "3px",
  padding: theme.spacing(1.5),
  width: SIZE + "px",
  height: SIZE + "px",
  minWidth: "unset",
  backdropFilter: "blur(5px)",
  pointerEvents: "auto",
}));
